import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import html2pdf from "html2pdf.js";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import {
    list
  } from "../../../../controllers/V1/k_winnInvoice/invoiceControllers";
import PreviewInvoice from '../preview';
const Invoice = () => {
    const { batch_id } = useParams();
    const printRef = useRef();
    const hiddenContainerRef = useRef();

    const [isLoading, setIsLoading] =useState(true);
    const [ALLLISTDATA, setListData] = useState([]);
    const [isProcessingDownload, setIsProcessingDownload] = useState(false);
    // Add state for progress tracking
    const [currentProcessingIndex, setCurrentProcessingIndex] = useState(0);
    const [totalInvoices, setTotalInvoices] = useState(0);

    /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    setIsProcessingDownload(true);
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          batch_no : batch_id, status : 'Completed'
        },
        select: {},
        sort: { _id: -1 },
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
        } else {
          setListData([]);
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
      setIsProcessingDownload(false);
    } catch (error) {
      setIsLoading(false);
      setIsProcessingDownload(false);
    }
  }; //End

    const generatePdf = async () => {
        const element = printRef.current;
        const options = {
            margin      : .25,
            filename    : "example.pdf",
            image       : { type: "jpeg", quality: 1 },
            html2canvas : { dpi: 1200, letterRendering: true, scale: 3, backgroundColor: '#fff' }, // force white background
            jsPDF       : { unit: "in", format: [8.5, 11], orientation: "portrait" }
        };
        html2pdf().from(element).set(options).save();
    };

    // Function to generate PDF from hidden DOM node
    const renderInvoiceToPdfBlob = (idx) => {
        return new Promise((resolve, reject) => {
            // Wait for DOM to be ready
            setTimeout(() => {
                const element = document.getElementById(`hidden-invoice-${idx}`);
                if (!element) return reject(new Error('Invoice DOM not found'));
                // Get invoice_no and store_name for filename
                const invoice = ALLLISTDATA[idx];
                let invoiceNo = `${invoice?.pos_number}` || `invoice_${idx + 1}`;
                // Sanitize filename (remove/replace invalid characters)
                invoiceNo = String(invoiceNo).toString().replace(/[^a-zA-Z0-9-_]/g, '_');
                const filename = `${invoiceNo}.pdf`;
                const options = {
                    margin      : .25,
                    filename    : filename,
                    image       : { type: "jpeg", quality: 1 },
                    html2canvas : { dpi: 1200, letterRendering: true, scale: 3, backgroundColor: '#fff' }, // force white background
                    jsPDF       : { unit: "in", format: [8.5, 11], orientation: "portrait" }
                };
                html2pdf()
                    .from(element)
                    .set(options)
                    .toPdf()
                    .output('blob')
                    .then((pdfBlob) => {
                        resolve({ blob: pdfBlob, filename });
                    })
                    .catch(reject);
            }, 0); // Ensure React has rendered
        });
    };

    // Helper for concurrency-limited processing
    const processWithConcurrency = async (tasks, limit, onProgress) => {
      let idx = 0;
      let completed = 0;
      const results = new Array(tasks.length);
      const queue = [];

      const runTask = async (taskIdx) => {
        try {
          const result = await tasks[taskIdx]();
          results[taskIdx] = result;
        } catch (e) {
          results[taskIdx] = null;
        }
        completed++;
        if (onProgress) onProgress(completed);
        if (idx < tasks.length) {
          const nextIdx = idx++;
          return runTask(nextIdx);
        }
      };

      // Start initial batch
      while (idx < limit && idx < tasks.length) {
        queue.push(runTask(idx++));
      }
      await Promise.all(queue);
      return results;
    };

    // Main function to download all invoices as ZIP
    const downloadAllInvoicesAsZip = async () => {
        setIsProcessingDownload(true);
        setCurrentProcessingIndex(0);
        setTotalInvoices(ALLLISTDATA.length);
        let isCancelled = false;
        // Cleanup if component unmounts
        const cleanup = () => { isCancelled = true; setIsProcessingDownload(false); };
        window.addEventListener('beforeunload', cleanup);
        try {
            if (!ALLLISTDATA || ALLLISTDATA.length === 0) {
                setIsProcessingDownload(false);
                window.removeEventListener('beforeunload', cleanup);
                return;
            }
            const zip = new JSZip();
            // Prepare tasks for each invoice
            const tasks = ALLLISTDATA.map((_, idx) => () => renderInvoiceToPdfBlob(idx));
            // Process with concurrency limit 3
            const results = await processWithConcurrency(tasks, 3, (done) => {
                if (!isCancelled) setCurrentProcessingIndex(done);
            });
            results.forEach((res) => {
                if (res) zip.file(res.filename, res.blob);
            });
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            if (!isCancelled) saveAs(zipBlob, `${batch_id}.zip`);
        } catch (err) {
            if (!isCancelled) alert('Failed to generate ZIP: ' + err.message);
        } finally {
            if (!isCancelled) setIsProcessingDownload(false);
            window.removeEventListener('beforeunload', cleanup);
        }
    };

    useEffect(()=>{
        getList();
    },[]);
    
  return (
  <div ref={printRef}>
    {/* Loading overlay */}
    {isProcessingDownload && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.4)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}>
        <div style={{
          border: '6px solid #f3f3f3',
          borderTop: '6px solid #1976d2',
          borderRadius: '50%',
          width: 50,
          height: 50,
          animation: 'spin 1s linear infinite',
          marginBottom: 20
        }} />
        <div style={{ color: '#fff', fontSize: 18 }}>Processing, please wait…</div>
        {/* Progress message */}
        {totalInvoices > 0 && (
          <div style={{ color: '#fff', fontSize: 16, marginTop: 10 }}>
            Zipping invoice {currentProcessingIndex} of {totalInvoices}...
          </div>
        )}
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    )}
    {/* Hidden container for off-screen rendering */}
    <div ref={hiddenContainerRef} style={{ display: 'none' }} />
    {/* Hidden container for PDF export, part of main React tree */}
    <div style={{ display: 'none' }}>
      {ALLLISTDATA?.length > 0 &&
        ALLLISTDATA.map((items, idx) => (
          <div key={idx} id={`hidden-invoice-${idx}`}>
            <PreviewInvoice nextInvoice={false} invoiceData={items} />
          </div>
        ))}
    </div>
    {ALLLISTDATA?.length > 0 && (
      <button
        onClick={downloadAllInvoicesAsZip}
        style={{ margin: '10px 0', padding: '8px 16px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: '4px', cursor: isProcessingDownload ? 'not-allowed' : 'pointer', opacity: isProcessingDownload ? 0.6 : 1 }}
        disabled={isProcessingDownload}
      >
        Download All Invoices (ZIP)
      </button>
    )}
    {ALLLISTDATA?.length > 0 && (
        ALLLISTDATA.map((items, index) => (
          <React.Fragment key={index}>
            <PreviewInvoice nextInvoice={false} invoiceData={items}/>
            <br/>
          </React.Fragment>
        ))
    )}
  </div>);
};

export default Invoice;
